
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { default as __Next_Translate_old_getServerSideProps__1a06c87eef7__ } from '@utils/serverSide/getBasicServerSideProps';
import Cgu from '@screens/LegalDocumentation/Cgu';
export {} from '@utils/serverSide/getBasicServerSideProps';
export default Cgu;

    async function __Next_Translate__getServerSideProps__1a06c87eef7__(ctx) {
      const res = await __Next_Translate_old_getServerSideProps__1a06c87eef7__(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/cgu',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a06c87eef7__ as getServerSideProps }
  